import { render, staticRenderFns } from "./SubjectGroupNewDialog.vue?vue&type=template&id=5c0f1452"
import script from "./SubjectGroupNewDialog.vue?vue&type=script&lang=js"
export * from "./SubjectGroupNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports